export default __webpack_public_path__ + "static/media/Meat-3.74a740fa.png";